// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"152":"a63280ab","181":"6e61fde0","187":"128079cf","215":"8e418e77","551":"42bdffc4","582":"65cfdb4e","644":"b804b2c6","761":"03874858","893":"87e393e7"}[chunkId] + ".js";
};